export function myPasswordPath() {
  return '/me/password'
}
